import {Link} from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';
import * as utils from './Utils';
import {Container} from 'react-bootstrap';
import * as footerStyles from '../Styles/footer.module.scss';

const Footer = ({footerData, siteMetadata}) => {
  const data = footerData;
  return (
    <>
      <footer id="footer" className={footerStyles.footer}>
        <Container className={footerStyles.container}>
          <div className={footerStyles.footerData}>
            <div className={footerStyles.footerPageLinks}>
              <div className={footerStyles.footerFacultyLinks}>
                <span className={footerStyles.sectionHeader}>
                  {data?.navigation?.[0]?.section?.title}
                </span>
                <div className={footerStyles.facultyLinksPartitions}>
                  <ul className={footerStyles.facultyCourseLinks}>
                    {data?.navigation?.[0]?.section?.
                        links.map((item, index) => {
                          return (
                            <li key={index}>
                              <Link to={item.facultypageurl}>
                                {item.title}
                              </Link>
                            </li>
                          );
                        })}
                  </ul>
                </div>
              </div>
              <div className={footerStyles.footerCompanyDetails}>
                <span className={footerStyles.sectionHeader}>
                  {data?.navigation?.[1]?.section?.title}
                </span>
                <ul>
                  {data?.navigation?.[1]?.section?.links
                      .map((company, index) => {
                        let pageUrl =
                        utils.getLocalizedPageLink(data?.locale,
                            company.staticpageurl);
                        const hrefProps={};
                        if (company.blogpageurl) {
                          pageUrl = company.blogpageurl;
                        } else if (company.reviewspageurl) {
                          pageUrl =
                        utils.getLocalizedPageLink(data?.locale,
                            company.reviewspageurl);
                        } else if (company.externalurl) {
                          return (
                            <li key={index}>
                              <a href={company.externalurl}>
                                {company.title}</a>
                            </li>
                          );
                        } else if (company?.staticpageurl &&
                          company.staticpageurl==='/about/') {
                          hrefProps.rel='noindex nofollow';
                        }
                        return (
                          <li key={index}>
                            <Link to={pageUrl} {...hrefProps}>
                              {company.title}
                            </Link>
                          </li>
                        );
                      })}
                  <li>
                    <a href={'https://www.upskillist.com/blog/'}
                      target='_blank' rel="noreferrer">
                      Blog
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className={footerStyles.socialLinks}>
              <div className={footerStyles.footerLogo}>
                <Link to="/">
                  <img src="/images/logo/brand-logo-footer.svg"
                    alt="brand"
                    className={footerStyles.desktopLogo}/>
                  {/* <img src="/images/logo/brand-mobile.png"
                    alt="brand"
                    className={footerStyles.mobileLogo}/> */}
                </Link>
              </div>
              <div className={footerStyles.footerLogoTagline}>
                <p>{data?.tagline}</p>
              </div>
              <div className={footerStyles.footerSlogan}>
                <p>Our courses are designed
                   intelligently so you can upskill with ease.</p>
              </div>
              <div className={footerStyles.mediaLinks}>
                <div className={footerStyles.socialIcons}>
                  <a href={`https://www.facebook.com/${siteMetadata.social.facebook}`}>
                    <img
                      alt={`${siteMetadata.title} Facebook Page`}
                      src="/images/social/new/facebook.svg" width="11"
                      height="20"/></a>
                </div>
                <div className={footerStyles.socialIcons}>
                  <a href={`https://www.instagram.com/${siteMetadata.social.instagram}`}>
                    <img
                      alt={`${siteMetadata.title} instagram`}
                      src="/images/social/new/instagram.svg" width="18"
                      height="18"/></a>
                </div>
                <div className={footerStyles.socialIcons}>
                  <a href={`https://www.linkedin.com/company/upskillist`}>
                    <img
                      alt={`${siteMetadata.title} Linkedin`}
                      src="/images/social/new/linkedin.svg" width="19"
                      height="18"/></a>
                </div>
                <div className={footerStyles.socialIcons}>
                  <a href={`https://twitter.com/${siteMetadata.social.twitter}`}>
                    <img
                      alt= {`${siteMetadata.title} Twitter`}
                      src="/images/social/new/twitter.svg"
                      height='20' width="16" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className={footerStyles.languageSection}></div>
        </Container>
        <div className={footerStyles.copyrightSection}>
          <Container className={footerStyles.container}>
            <div className={footerStyles.copyrightData}>
              <div className={footerStyles.copyrights}>
                <p>{data && data['single_line']}</p>
              </div>
              <div className={footerStyles.policyLinks}>
                {data?.bottomnavigation
                    .map((navs, index)=>{
                      const link =
                    utils.getLocalizedPageLink(data?.locale, navs.url);
                      return <Link key={index} to={link}>{navs.title}</Link>;
                    })}
              </div>
            </div>
          </Container>
        </div>
      </footer>
    </>
  );
};

Footer.propTypes = {
  footerData: PropTypes.object,
  siteMetadata: PropTypes.object,
};

export default Footer;
